import React from "react"
import styled from "styled-components"
import ShareIcon from "@material-ui/icons/Share"
import { Button as MuiButton } from "@material-ui/core"

const Button = styled(MuiButton)`
  margin-top: 5px;
  border: 1px solid gray;
  border-radius: 5px;
  padding: 5px;
  min-width: 0;
  text-transform: none;
  .MuiButton-startIcon {
    margin-right: 0px;
    margin-left: 0px;
  }
`

const Label = styled.span`
  margin-left: 5px;
  margin-right: 5px;
  line-height: 1;
`

export const ShareButton = props => {
  const { clientUrl, title, label, description } = props

  const handleShareClick = () => {
    if (navigator.share) {
      navigator
        .share({
          title: title,
          url: clientUrl,
          text: description,
        })
        .catch(error => {
          console.error("Error sharing:", error)
        })
    } else {
      const mailtoLink = `mailto:?subject=${encodeURIComponent(
        title
      )}&body=${encodeURIComponent(description + "\n\n" + clientUrl)}`
      window.open(mailtoLink)
    }
  }

  if (!clientUrl) return null

  return (
    <Button onClick={handleShareClick} title={title} startIcon={<ShareIcon />}>
      {label && <Label>{label}</Label>}
    </Button>
  )
}
